import { put, takeLatest, select, cancel } from 'redux-saga/effects';
import { merge } from 'lodash';

import {
  paginatedConsts as upcomingSurveys,
  paginatedActions,
} from '../upcoming';
import {
  selectUpcomingList,
  selectUpcomingListCounter,
  upcomingPaginationSelector,
} from '../selectors';

function* upcomingSurveysPaginationWorker(action) {
  const { payload } = action;
  const { limit, id } = payload;

  const paginationOptions = yield select(upcomingPaginationSelector);
  const requestsTotal = yield select(selectUpcomingListCounter);
  const existingRequests = yield select(selectUpcomingList);

  if (requestsTotal <= existingRequests.length) {
    yield cancel();
  }

  const params = merge({}, paginationOptions, {
    offset: existingRequests.length,
    limit,
    id,
  });

  yield put(paginatedActions.updatePaginationParameters(params));

  yield put({
    type: upcomingSurveys.SEND,
    payload: params,
  });
}

export default function* upcomingSurveysPaginationSaga() {
  yield takeLatest(
    upcomingSurveys.LOAD_NEXT_REQUESTS,
    upcomingSurveysPaginationWorker,
  );
}



// WEBPACK FOOTER //
// ./src/redux/surveys/sagas/upcoming-surveys-pagination-saga.js